export const OTP_CODE_LENGTH = 6;
export const OTP_DIGITS_REGEX = /^\d+$/;

export const formatOtp = (text: string): string =>
  text.replace(/\D/g, '').slice(0, OTP_CODE_LENGTH);
